import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr 351px;
  grid-template-rows: 280px 180px 148px;
  padding: 32px;
`;
